import React, { useState, useEffect } from 'react';
import Icon from 'components/commons/icon/Icon';
import { getRoutingStorage, updateRoutingStorage } from 'utils/storage';

export const updateRoutigList = (page: string): void => {
  const url = new URL(window.location.href);
  const searchParams = url.searchParams;
  searchParams.set('page', page.toString());

  url.search = searchParams.toString();
  const newUrl = url.toString();
  window.history.replaceState(
    { ...window.history.state, as: newUrl, url: newUrl },
    '',
    newUrl
  );

  const routing = getRoutingStorage();
  if (routing === null) return;
  routing.routeList.pop();

  const updateRotuignList = {
    ...routing.routeList,
    path: `/tradehistory?page=${page}`,
  };
  routing.routeList.push(updateRotuignList);
  updateRoutingStorage(routing);
};

export type PageParamType = {
  startPage: number;
  selectPage: number;
  totalPageCount: number | undefined;
};

type PaginationProps = {
  startPage: number | undefined;
  selectPage: number | undefined;
  totalPageCount: number | undefined;
  onChangePage: (newPageParam: PageParamType) => void;
};

// ページボタンのテキスト
function getPageButtonsText(pageParam: PageParamType): string[] {
  const { startPage, totalPageCount } = pageParam;
  const pageBtnCount = calcDisplayPageButtonNum();

  if (
    pageBtnCount <= 2 ||
    startPage === 0 ||
    totalPageCount === 0 ||
    totalPageCount === undefined
  ) {
    return [];
  }

  let len = totalPageCount - startPage + 1;
  if (len > pageBtnCount - 2) {
    len = pageBtnCount - 2;
  }

  const arr: string[] = new Array(len);
  for (let n = 0; n < len; n++) {
    arr[n] = (startPage + n).toString();
  }
  arr.unshift('<');
  arr.push('>');

  return arr;
}

// 画面幅に合わせたページボタンの表示数
function calcDisplayPageButtonNum(): number {
  const maxCnt = 10;
  const num = Math.floor(window.parent.screen.width / 40) - 2;
  return num > maxCnt ? maxCnt : num;
}

// ページ管理の初期値
function getInitPageParamType(
  startPage: number,
  selectPage: number,
  totalPageCount: number
): PageParamType {
  let initStartPage = 0;
  let initSelectPage = 0;
  let initTotalPageCount = 0;

  if (
    startPage <= selectPage &&
    selectPage <= totalPageCount &&
    selectPage < startPage + totalPageCount
  ) {
    initStartPage = startPage;
    initSelectPage = selectPage;
    initTotalPageCount = totalPageCount;
  }

  return {
    startPage: initStartPage,
    selectPage: initSelectPage,
    totalPageCount: initTotalPageCount,
  };
}

// ページネーション
const PaginationOrderList: React.FC<PaginationProps> = props => {
  const {
    startPage,
    selectPage,
    totalPageCount,
    onChangePage: onChangePage_,
  } = props;
  const [pageParam, setPageParam] = useState<PageParamType>(() =>
    getInitPageParamType(startPage ?? 0, selectPage ?? 0, totalPageCount ?? 0)
  );

  // ページボタンのテキスト
  const pageButtonsText = getPageButtonsText(pageParam);

  // ページボタンビュー
  const paginationView = pageButtonsText.map((item, index) => {
    const btnClass =
      (item === pageParam?.selectPage.toString()
        ? 'bg-blue-700 text-white'
        : 'bg-white cursor-pointer') +
      ' text-center items-center rounded w-10 h-10 p-2 m-1';

    const onPageChange = () => {
      const { startPage, selectPage, totalPageCount } = pageParam;

      if (!startPage || !selectPage || !totalPageCount) return;

      let stPage = startPage;
      let newPage = selectPage;
      if (item === '<') {
        if (selectPage > 1) {
          newPage = selectPage - 1;
          if (newPage === startPage - 1) {
            stPage--;
          }
        }
      } else if (item === '>') {
        if (selectPage < totalPageCount) {
          newPage = selectPage + 1;
          const displayNum = calcDisplayPageButtonNum();
          if (newPage === startPage + displayNum - 2) {
            stPage++;
          }
        }
      } else {
        newPage = Number(item);
      }

      if (newPage !== selectPage) {
        window.scroll({ top: 0 });
        const newPageParam = {
          ...pageParam,
          startPage: stPage,
          selectPage: newPage,
        };

        onChangePage_(newPageParam);
        updateRoutigList(newPage.toString());
      }
    };

    return (
      <div className={btnClass} key={index} onClick={onPageChange}>
        {item === '<' ? (
          <Icon name="chevron-left" />
        ) : item === '>' ? (
          <Icon name="chevron-right" />
        ) : (
          item
        )}
      </div>
    );
  });

  useEffect(() => {
    setPageParam(currentPageParam => {
      if (
        currentPageParam.startPage === startPage &&
        currentPageParam.selectPage === selectPage &&
        currentPageParam.totalPageCount === totalPageCount
      ) {
        return currentPageParam;
      }

      const newPageParam = {
        ...currentPageParam,
        startPage: startPage ?? 0,
        selectPage: selectPage ?? 0,
        totalPageCount: totalPageCount ?? 0,
      };
      return newPageParam;
    });
  }, [startPage, selectPage, totalPageCount]);

  return (
    <div
      className={`flex justify-center py-2 ${
        (totalPageCount ?? 0) > 1 ? '' : 'hidden'
      }`}>
      {paginationView}
    </div>
  );
};

export default PaginationOrderList;
